export const SLICK_SETTING = {
  dots: false,
  infinite: true,
  speed: 400,
  vertical: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  arrows: false,
  swipe: false,
};
